import { AppConfig, CONFIG_KEYS, defaultConfig } from '../config';
import { localStore } from './store';

class ConfigService {
  private config: AppConfig = defaultConfig;

  async init() {
    try {
      const storedConfig = await localStore.getItem<Record<string, any>>(CONFIG_KEYS.APP_CONFIG);
      if (storedConfig) {
        // Migrate: remove legacy api key that no longer exists in AppConfig
        delete storedConfig.api;

        this.config = {
          ...defaultConfig,
          ...(storedConfig as Partial<AppConfig>),
          model: {
            ...defaultConfig.model,
            ...storedConfig.model,
          },
          app: {
            ...defaultConfig.app,
            ...storedConfig.app,
          },
          shortcuts: {
            ...defaultConfig.shortcuts!,
            ...(storedConfig.shortcuts ?? {}),
          } as AppConfig['shortcuts'],
        };
      }
    } catch (error) {
      console.error('Failed to load config:', error);
    }
  }

  getConfig(): AppConfig {
    return this.config;
  }

  async updateConfig(newConfig: Partial<AppConfig>) {
    this.config = {
      ...this.config,
      ...newConfig,
    };
    await localStore.setItem(CONFIG_KEYS.APP_CONFIG, this.config);
  }

  async setDefaultModel(modelId: string) {
    if (this.config.model.defaultModel === modelId) return;
    await this.updateConfig({
      model: { ...this.config.model, defaultModel: modelId },
    });
  }
}

export const configService = new ConfigService();
